import React from 'react';
import styles from './Button.module.css';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  size?: 's' | 'm' | 'l';
  children: React.ReactNode;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'm', 
  ...props
}) => (
  <button
    className={[styles.button, styles[variant], styles[size]].join(' ')}
    {...props}
  >
    {children}
  </button>
);